import React from "react";
// import { useContext } from "react";
import axios from 'axios';


import Grid from "@mui/material/Grid";


// import { createTheme, ThemeProvider } from "@mui/material/styles";

// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
import DropDownSelector from "./DropDownSelector";
import MessageSnackBar from "./MessageSnackBar";
// import { UserContext } from '../context/UserContext.js';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext.js';



// const theme = createTheme();

// const darkTheme = createTheme({
//   palette: {
//     mode: "dark",
//   },
// });


export default function AccountDropDown(props) {

    //SECTION USER CONTEXT and HEADERS
    const userData = useContext(UserContext);
    const storedHeaders = sessionStorage.getItem('headers');
    const headers = storedHeaders ? JSON.parse(storedHeaders) : {};
    // !SECTION

  //! Local SnackBar Messaging



 //SECTION Message Bar Controls
 const [ messageBarMessage, setMessageBarMessage ] = React.useState('');
 const [ messageBarOpen, setMessageBarOpen ] = React.useState(false);
 const [ messageSeverity, setMessageSeverity ] = React.useState('success')
 const handleMessageBarClosing = () => {
   setMessageBarOpen(false);
 };
 //!SECTION


  const handleSelectedAccount = (accountName) => {
    const result = accountList.find( ({ value }) => value === accountName );
    props.handleSelectedAccount(accountName, result.accountCode, result.membershipCode)
  };



  // !Down to AccountDrop Down
  const [accountList, setAccountList] = React.useState([
    {
      id: 1,
      label: "Default Regions",
      value: "Zip_Metros_Default.csv",
    },
  ]);

  //Variables to send down
  const accountsTitles = {
    dropDownTitle: "Select An Account",
    dropDownButtonTitle: "Load Account",
    dropDownLabel: "Select An Account",
    dropDownHelperText: "Files will load under your if not selected.",
    dropDownAlertMessage: "Files will load under " ,
    buttonView: true
  };
    //! Items for Dropdown
  // Get accounts list from Database
  //SECTION Axios get Account List

  const getAccountList = React.useCallback(() => {
    // const headers = props.headers;
    axios
      .get(`information/listaccounts`, { headers: headers })
      .then(function (response) {
        setAccountList(response.data);
        // console.log(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        //!Message bar
        setMessageBarMessage(`Oh no! Something went wrong. Please try again or email info@edonconnect.tech for help. ${error.message}`);
        setMessageBarOpen(true);
        setMessageSeverity("error"); // error: red, warning: orange, information: blue, success: green
      })
      .then(function () {
        // always executed
      });
  }, [props.headers]); // Memoize with dependencies

  React.useEffect(() => {
    getAccountList();
  }, [getAccountList]);





  //!SECTION


  return (
    <Grid
      container
      marginTop={1}
      sx={{
        justifyContent: "center",
        alignContent: "center",
        p: 1,
        border: 0,
        borderStyle: "dotted",
        borderRadius: "5px",
      }}
    >
      <MessageSnackBar messageBarMessage={messageBarMessage} messageBarOpen={messageBarOpen} handleMessageBarClosing={handleMessageBarClosing} messageSeverity={messageSeverity} />
          <DropDownSelector
                itemList={accountList}
                handleSelectedItem={handleSelectedAccount}
                dropDownTitles={accountsTitles}
                toggleClose={props.toggleAccounts}
            />

    </Grid>
  );
}